const MESSAGE_PROFILE_DUPLICATE =
  'Nome de perfil já existente para este tipo de acesso. Por favor, verifique os dados informados.';
const MESSAGE_PROFILE_ERROR = 'Ocorreu um erro ao criar o Perfil';
const MESSAGE_USER_ERROR = 'Ocorreu um erro ao criar o Usuário';
const MESSAGE_USER_DUPLICATE =
  'CPF já cadastrado. Por favor, verifique os dados informados.';
const MESSAGE_DOCTOR_ERROR = 'Ocorreu um erro ao criar o Médico';
const MESSAGE_DOCTOR_LOAD_ERROR = 'Ocorreu um erro ao carregar o item';
const MESSAGE_DOCTOR_CRM_DUPLICATE =
  'CRM/UF já cadastrado. Por favor, verifique os dados informados';
const MESSAGE_DOCTOR_UPDATE_ERROR = 'Ocorreu um erro ao atualizar o médico';

const MESSAGE_BUSINESS_UNIT_ERROR = 'Ocorreu um erro ao criar a Empresa';
const MESSAGE_BUSINESS_UNIT_LOAD_ERROR =
  'Ocorreu um erro ao carregar a Empresa';
const MESSAGE_BUSINESS_UNIT_CNPJ_DUPLICATE =
  'CNPJF já cadastrado. Por favor, verifique os dados informados';
const MESSAGE_BUSINESS_UNIT_UPDATE_ERROR =
  'Ocorreu um erro ao atualizar a Empresa';

const MESSAGE_PARAMETER_ERROR = 'Ocorreu um erro ao criar a Hierarquia';
const MESSAGE_PARAMETER_DUPLICATE =
  'Existe dados duplicados no cadastro. Por favor, verifique os dados informados';
const MESSAGE_RULE_OVERRIDE_ERROR = 'Ocorreu um erro ao criar a Hierarquia';
const MESSAGE_RULE_OVERRIDE_DUPLICATE =
  'Existe dados duplicados no cadastro. Por favor, verifique os dados informados';
const MESSAGE_RULE_ERROR = 'Ocorreu um erro ao salvar a Regra';
const MESSAGE_RULE_DELETE_ERROR = 'Ocorreu um erro ao deletar a regra';
const MESSAGE_RULE_DUPLICATE =
  'Código já cadastrado. Por favor, verifique os dados informados';
const MESSAGE_RULE_HAS_OVERRIDE_DUPLICATE =
  'Existe hierarquia vinculadas a essa regra, remova as hierarquias antes de deletar.';
const MESSAGE_TEAM_ERROR = 'Ocorreu um erro ao criar o time';
const MESSAGE_TEAM_DOCTOR_DUPLICATE =
  'Os seguintes médicos já fazem parte de um time nessa unidade:';
const MESSAGE_TRANSCRIPTION_ERROR = 'Houve um erro ao salvar a transcrição';
const MESSAGE_TRANSCRIPTION_ON_LOAD_ERROR =
  'Houve um erro ao carregar a transcrição';
const MESSAGE_TRANSCRIPTION_IN_PROGRESS =
  'Essa transcrição já está em progresso.';
const MESSAGE_PRESCRIPTION_ERROR = 'Houve um erro ao salvar a prescrição';
const MESSAGE_PRESCRIPTION_LOAD_ERROR =
  'Houve um erro ao carregar a prescrição';
const MESSAGE_FILE_NOT_SELECTED = 'Nenhum arquivo selecionado';
const MESSAGE_INVALID_FILE = 'Formato inválido';
const MESSAGE_INVALID_SIZE = 'Dimensões da imagem incorretas';
const MESSAGE_FILE_SIZE_EXCEEDED =
  'O arquivo excedeu o tamanho máximo permitido';
const MESSAGE_FILE_ERROR_UPLOAD = 'Houve um erro ao fazer o upload do arquivo';
const MESSAGE_FILE_ERROR_DELETE = 'Houve um erro ao fazer deletar o arquivo';
const MESSAGE_PRODUCT_ERROR = 'Ocorreu um erro ao salvar o produto';
const MESSAGE_PRODUCT_DELETE_ERROR = 'Ocorreu um erro ao deletar o produto';
const MESSAGE_LOGIN_ERROR =
  'Houve um erro ao realizar o login, tente novamente.';
const MESSAGE_LOGIN_PASSWORD_ERROR =
  'Login ou senha inválidos, tente novamente.';
const MESSAGE_LOGIN_UNAUTHORIZED_ERROR =
  'Usuário bloqueado. Por favor entrar em contato com o administrador do sistema.';
const MESSAGE_FIRST_ACCESS_ERROR =
  'Houver um erro ao definir a senha. Por favor, tente novamente.';
const MESSAGE_TITLE_CFM_ERROR = 'Erro ao consultar o CRM';
const MESSAGE_CFM_ERROR =
  'Houve um erro ao realizar a consulta do CRM. Por favor tente novamente.';
const MESSAGE_CFM_INVALID =
  'Médico sem acesso ao sistema e impossibilitado de prescrever.';
const MESSAGE_TITLE_CFM_INVALID = (situacao: string = '') => {
  return `Situação irregular ${situacao} no CFM`;
};
const MESSAGE_MATERIALS_ERROR = 'Ocorreu um erro ao salvar o registro';
const MESSAGE_MATERIALS_DUPLICATE = 'Já existe um Ativo com esse código';
const MESSAGE_MATERIALS_DELETE_ERROR = 'Ocorreu um erro ao excluir o registro';
const MESSAGE_PRESCRIPTION_MODEL_ERROR =
  'Houve um erro ao carregar o modelo. Por favor, tente novamente.';
const MESSAGE_PRESCRIPTION_COPY_ERROR =
  'Houve um erro ao carregar a cópia. Por favor, tente novamente.';
const MESSAGE_PRESCRIPTION_PROFILE_ERROR =
  'Houve um erro ao carregar o perfil. Por favor, tente novamente.';
const MESSAGE_PRESCRIPTION_PATTERN_ERROR =
  'Houve um erro ao carregar o padrão. Por favor, tente novamente.';
const MESSAGE_GROUPS_DELETE_ERROR = 'Ocorreu um erro ao excluir o registro';
const MESSAGE_SUBGROUPS_DELETE_ERROR = 'Ocorreu um erro ao excluir o registro';
const MESSAGE_EXPRESSIONS_DELETE_ERROR =
  'Ocorreu um erro ao excluir o registro';
const MESSAGE_APPROVE_ERROR = 'Ocorreu um erro ao atualizar';
const MESSAGE_PRESCRIPTION_TEMPLATE_ERROR =
  'Ocorreu um erro ao salvar o template';

export {
  MESSAGE_PROFILE_DUPLICATE,
  MESSAGE_PROFILE_ERROR,
  MESSAGE_USER_DUPLICATE,
  MESSAGE_USER_ERROR,
  MESSAGE_DOCTOR_CRM_DUPLICATE,
  MESSAGE_DOCTOR_ERROR,
  MESSAGE_DOCTOR_LOAD_ERROR,
  MESSAGE_DOCTOR_UPDATE_ERROR,
  MESSAGE_BUSINESS_UNIT_CNPJ_DUPLICATE,
  MESSAGE_BUSINESS_UNIT_ERROR,
  MESSAGE_BUSINESS_UNIT_LOAD_ERROR,
  MESSAGE_BUSINESS_UNIT_UPDATE_ERROR,
  MESSAGE_PARAMETER_ERROR,
  MESSAGE_PARAMETER_DUPLICATE,
  MESSAGE_RULE_ERROR,
  MESSAGE_RULE_DUPLICATE,
  MESSAGE_RULE_DELETE_ERROR,
  MESSAGE_RULE_HAS_OVERRIDE_DUPLICATE,
  MESSAGE_RULE_OVERRIDE_ERROR,
  MESSAGE_RULE_OVERRIDE_DUPLICATE,
  MESSAGE_TEAM_ERROR,
  MESSAGE_TEAM_DOCTOR_DUPLICATE,
  MESSAGE_TRANSCRIPTION_ERROR,
  MESSAGE_TRANSCRIPTION_ON_LOAD_ERROR,
  MESSAGE_TRANSCRIPTION_IN_PROGRESS,
  MESSAGE_PRESCRIPTION_ERROR,
  MESSAGE_PRESCRIPTION_LOAD_ERROR,
  MESSAGE_FILE_NOT_SELECTED,
  MESSAGE_INVALID_FILE,
  MESSAGE_INVALID_SIZE,
  MESSAGE_FILE_SIZE_EXCEEDED,
  MESSAGE_FILE_ERROR_UPLOAD,
  MESSAGE_FILE_ERROR_DELETE,
  MESSAGE_PRODUCT_ERROR,
  MESSAGE_PRODUCT_DELETE_ERROR,
  MESSAGE_FIRST_ACCESS_ERROR,
  MESSAGE_LOGIN_ERROR,
  MESSAGE_LOGIN_PASSWORD_ERROR,
  MESSAGE_LOGIN_UNAUTHORIZED_ERROR,
  MESSAGE_TITLE_CFM_ERROR,
  MESSAGE_CFM_ERROR,
  MESSAGE_TITLE_CFM_INVALID,
  MESSAGE_CFM_INVALID,
  MESSAGE_MATERIALS_ERROR,
  MESSAGE_MATERIALS_DUPLICATE,
  MESSAGE_MATERIALS_DELETE_ERROR,
  MESSAGE_PRESCRIPTION_MODEL_ERROR,
  MESSAGE_PRESCRIPTION_COPY_ERROR,
  MESSAGE_PRESCRIPTION_PROFILE_ERROR,
  MESSAGE_PRESCRIPTION_PATTERN_ERROR,
  MESSAGE_GROUPS_DELETE_ERROR,
  MESSAGE_SUBGROUPS_DELETE_ERROR,
  MESSAGE_EXPRESSIONS_DELETE_ERROR,
  MESSAGE_APPROVE_ERROR,
  MESSAGE_PRESCRIPTION_TEMPLATE_ERROR,
};
